import React from "react";
import { Redirect, Route, Switch } from "react-router-dom";
import CreateCustomer from "./CreateApartmentCustomer";
import CustomerDetails from './ApartmentCustomerDetails';
import CustomerList from "./ApartmentCustomerList";
import EditCustomerDetails from "./EditApartmentCustomer";
import CreateApartmentuserInfo from "./CreateApartmentuserInfo";
import CreateApartmentuserInfoagg from "./CreateApartmentuserInfoagg";

export default function ApartmentCustomer() {
  return (
    <Switch>
      <Redirect exact={true} from="/aprt-customer" to="/aprt-customer/customer-list" />

      {/* Layout */}
      <Route exact={true} path="/aprt-customer/customer-list" component={CustomerList} />
      <Route exact={true} path="/aprt-customer/customer-details" component={CustomerDetails} />
      <Route exact={true} path="/aprt-customer/customer-create" component={CreateCustomer} />
      <Route exact={true} path="/aprt-customer/customer-edit" component={EditCustomerDetails} />
      <Route exact={true} path="/aprt-customer/customer-user-create" component={CreateApartmentuserInfo} />
	  <Route exact={true} path="/aprt-customer/customer-user-create-agg" component={CreateApartmentuserInfoagg} />
    </Switch>
  );
}
